module.exports = __webpack_public_path__ + "static/hero-bg-aeb627905beb7339fdb0d24ccddab090.jpg";